export default {
  'dashboard.ProportionSales.salesCategoryProportion': 'Tỷ lệ danh mục doanh số',
  'dashboard.ProportionSales.allChannels': 'Tất cả kênh',
  'dashboard.ProportionSales.online': 'Trực tuyến',
  'dashboard.ProportionSales.offline': 'Chi nhánh',
};
